import { render, staticRenderFns } from "./ManagementCategory.vue?vue&type=template&id=fca28666&scoped=true&"
import script from "./ManagementCategory.vue?vue&type=script&lang=ts&"
export * from "./ManagementCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementCategory.vue?vue&type=style&index=0&id=fca28666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca28666",
  null
  
)

export default component.exports